module.exports = "<symbol id=\"thebestco-uikit-svg-Minimize16\" viewBox=\"0 0 16 16\"><path d=\"M0 7H16V9H0z\"/></symbol>";